import React, { useState } from "react";
import Draggable from "react-draggable";
import { SketchPicker } from "react-color";

export const DynamicSoftCostModal = ({ onCancel, onFilterSave, selectedDynamicField = {}, isSubmitting = false, heading = null }) => {
    const [showErrorBorder, setShowErrorBorder] = useState(false);
    const [showColorPicker, setShowColorPicker] = useState(false);

    const [FilterData, setFilterData] = useState({
        name: selectedDynamicField?.name || "",
        field_type: selectedDynamicField?.field_type || "dollar_per_sf",
        color_code: selectedDynamicField?.color_code || "#3E8EDE"
    });

    const validate = () => {
        setShowErrorBorder(false);
        if (!FilterData.name && !FilterData.name?.trim()?.length) {
            setShowErrorBorder(true);
            return false;
        }
        return true;
    };
    const submitSaveFilter = () => {
        if (validate()) {
            onFilterSave(FilterData);
        }
    };

    const styles = {
        swatch: {
            width: 40,
            height: 24,
            borderRadius: 4,
            border: "1px solid #ddd",
            cursor: "pointer",
            display: "inline-block"
        },
        color: bg => ({
            width: "100%",
            height: "100%",
            borderRadius: 4,
            background: bg
        }),
        popover: {
            position: "absolute",
            zIndex: 2
        },
        cover: {
            position: "fixed",
            top: 0,
            right: 0,
            bottom: 0,
            left: 0
        }
    };

    const isEdit = selectedDynamicField?.key;
    return (
        <>
            <div className="modal modal-region modal-view inbox-modal" id="modalId" tabIndex="-1" style={{ display: "block" }}>
                <Draggable handle=".draggable" cancel=".non-draggable">
                    <div className="modal-dialog" role="document">
                        <div className="modal-content">
                            <div className="modal-header draggable">
                                <h5 className="modal-title" id="exampleModalLabel">
                                    <div className="txt-hed">
                                        {isEdit ? "Edit" : "Add New"} {heading ? heading : "Soft Cost"}
                                    </div>
                                </h5>
                                <button type="button" className="close non-draggable" onClick={onCancel}>
                                    <span aria-hidden="true">
                                        <img src="/img/close.svg" alt="" />
                                    </span>
                                </button>
                            </div>
                            <div className="modal-body region-otr sm-chart-upload">
                                <div className="col-md-12 main-sec">
                                    <div className="form-row">
                                        <div className="form-group col-12 mb-4">
                                            <label>Name</label>
                                            <input
                                                type="text"
                                                placeholder="Name"
                                                value={FilterData.name}
                                                onChange={e => {
                                                    const { value } = e.target;
                                                    setFilterData(prev => ({ ...prev, name: value }));
                                                }}
                                                className={`form-control ${
                                                    showErrorBorder && (!FilterData.name || !FilterData.name.trim().length) ? "error-border" : ""
                                                }`}
                                            />
                                        </div>
                                        <div className="form-group col-12 mb-4">
                                            <label>Input Type</label>
                                            <div className="form-check">
                                                <input
                                                    className="form-check-input cursor-hand"
                                                    type="radio"
                                                    name="field_type"
                                                    id="dollar_per_sf"
                                                    checked={FilterData.field_type === "dollar_per_sf"}
                                                    onChange={() => setFilterData(prev => ({ ...prev, field_type: "dollar_per_sf" }))}
                                                />
                                                <label className="form-check-label cursor-hand" htmlFor="dollar_per_sf">
                                                    Dollar per SF
                                                </label>
                                            </div>
                                            <div className="form-check">
                                                <input
                                                    className="form-check-input cursor-hand"
                                                    type="radio"
                                                    name="field_type"
                                                    id="dollar"
                                                    checked={FilterData.field_type === "dollar"}
                                                    onChange={() => setFilterData(prev => ({ ...prev, field_type: "dollar" }))}
                                                />
                                                <label className="form-check-label cursor-hand" htmlFor="dollar">
                                                    Flat
                                                </label>
                                            </div>
                                        </div>
                                        <div className="form-group col-12 mb-4 non-draggable" style={{ position: "relative" }}>
                                            <label>Color</label>
                                            <div className="form-check">
                                                <div
                                                    role="button"
                                                    aria-label="Choose color"
                                                    tabIndex={0}
                                                    onClick={() => setShowColorPicker(true)}
                                                    onKeyDown={e => (e.key === "Enter" || e.key === " ") && setShowColorPicker(true)}
                                                    style={styles.swatch}
                                                >
                                                    <div style={styles.color(FilterData.color_code)} />
                                                </div>

                                                {showColorPicker ? (
                                                    <div style={styles.popover}>
                                                        <div
                                                            style={styles.cover}
                                                            className="non-draggable"
                                                            onClick={() => setShowColorPicker(false)}
                                                        />
                                                        <SketchPicker
                                                            className="non-draggable"
                                                            color={FilterData.color_code}
                                                            presetColors={[
                                                                "#95cd50",
                                                                "#ffe242",
                                                                "#ffa105",
                                                                "#ff0305",
                                                                "#0018A8",
                                                                "#800080",
                                                                "#3E8EDE",
                                                                "#417505"
                                                            ]}
                                                            onChange={col => {
                                                                const next = col?.hex || FilterData.color_code;
                                                                setFilterData(prev => ({ ...prev, color_code: next }));
                                                            }}
                                                            onChangeComplete={col => {
                                                                const next = col?.hex || FilterData.color_code;
                                                                setFilterData(prev => ({ ...prev, color_code: next }));
                                                            }}
                                                        />
                                                    </div>
                                                ) : null}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="btn-sec">
                                    <div className="text-right btnOtr edit-cmn-btn">
                                        <button type="button" className="btn btn-create save" disabled={isSubmitting} onClick={submitSaveFilter}>
                                            {isEdit ? "Update" : "Add"}
                                            {isSubmitting && <span className="spinner-border spinner-border-sm pl-2" role="status"></span>}
                                        </button>
                                        <button
                                            type="button"
                                            className="btn btn-secondary btnClr mr-1"
                                            data-dismiss="modal"
                                            disabled={isSubmitting}
                                            onClick={onCancel}
                                        >
                                            Cancel
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </Draggable>
            </div>
        </>
    );
};
